var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card dataBox" },
        [
          _c(
            "el-table",
            { staticClass: "mt10 width100", attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "节点名称", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkPermi([
                          "admin:merchant:reservation:to:store:edit",
                        ])
                          ? _c(
                              "div",
                              [
                                scope.row.status
                                  ? _c("el-switch", {
                                      attrs: {
                                        disabled: "",
                                        "active-value": true,
                                        "inactive-value": false,
                                        "active-text": "开启",
                                        "inactive-text": "关闭",
                                      },
                                      model: {
                                        value: scope.row.status,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "status", $$v)
                                        },
                                        expression: "scope.row.status",
                                      },
                                    })
                                  : _c("el-switch", {
                                      attrs: {
                                        "active-value": true,
                                        "inactive-value": false,
                                        "active-text": "开启",
                                        "inactive-text": "关闭",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.statusChange(scope.row)
                                        },
                                      },
                                      model: {
                                        value: _vm.form[scope.row.key],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, scope.row.key, $$v)
                                        },
                                        expression: "form[scope.row.key]",
                                      },
                                    }),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(scope.row.status ? "开启" : "关闭")
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "info", label: "说明" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(scope.row.info) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }